import React, { useState } from "react";
import { Field as FormikField } from "formik";
import cx from "classnames";
import { useTranslation } from "gatsby-plugin-react-i18next";

export const Field = ({
  label,
  name,
  prefixIcon,
  className,
  type,
  children,
}) => {
  const { t } = useTranslation("support");
  const [isActive, setIsActive] = useState(false);

  return (
    <FormikField name={name}>
      {({ field, form, meta }) => {
        const handleChange = (e) => {
          if (typeof e === "number" || typeof e === "string") {
            setIsActive(Boolean(e));
            form.setFieldValue(name, e);
          } else {
            if (e.target.value === "") {
              setIsActive(false);
              form.setFieldValue(name, e.target.value);
            } else {
              setIsActive(true);
              form.setFieldValue(name, e.target.value);
            }
          }
        };

        const handleBlur = () => {
          form.setFieldTouched(name, true);
          if (type === "date") {
            setIsActive(true);
          }
        };

        const handleClick = () => {
          setIsActive(true);
        };

        const isError = meta.touched && meta.error;

        if (field.value) {
          setIsActive(true);
        }

        return (
          <div className={cx("block w-full", className)}>
            <div className="w-full relative bg-white" onClick={handleClick}>
              {React.Children.map(children, (child) => {
                if (React.isValidElement(child)) {
                  return React.cloneElement(child, {
                    className: cx("bg-transparent", {
                      "float-label-active": label && isActive,
                      "form-item-error": isError,
                    }),
                    name: field.name,
                    defaultValue: field.value,
                    onChange: handleChange,
                    onBlur: (e) => handleBlur(e),
                    value: field.value,
                  });
                }
              })}
              {label && (
                <label
                  className={cx(
                    "font-mulish text-gray-dark tracking-2 transition-all duration-100 ease-in absolute inset-x-0 h-fit-content px-13 my-auto z-1 pointer-events-none",
                    {
                      "text-10 top-6 font-semibold": isActive,
                      "text-14 top-14": !isActive,
                      "pl-48": prefixIcon,
                    }
                  )}>
                  {label}
                </label>
              )}
            </div>

            {isError && (
              <div className="block font-mulish text-12 leading-20 text-red-error mt-6">
                {t(meta.error)}
              </div>
            )}
          </div>
        );
      }}
    </FormikField>
  );
};
Field.defaultProps = {
  name: "",
  label: "",
  className: "",
};

export const FieldGroup = ({ name, className, label, children }) => {
  const { t } = useTranslation("support");
  const [isError, setIsError] = useState();
  return (
    <div className="block w-full">
      {label && (
        <label
          className={cx(
            "block font-mulish text-12-22 text-gray-text-2 tracking-2 mb-14"
          )}>
          {label}
        </label>
      )}
      <div className={cx("w-full relative bg-white", className)}>
        {React.Children.map(children, (child) => {
          if (React.isValidElement(child)) {
            return React.cloneElement(child, {
              name: name,
              onChange: (e) => setIsError(e),
            });
          }
        })}
      </div>

      {isError && (
        <div className="block font-mulish text-12 leading-20 text-red-error mt-6">
          {t(isError)}
        </div>
      )}
    </div>
  );
};
FieldGroup.defaultProps = {
  name: "",
  label: "",
  className: "",
};
